import { useState } from "react";
import { submitFormMutation } from "../../data-service/forms/functions";

export const TargetingStrategy = ({ title, description }) => {
  const [email, setEmail] = useState("");
  const [hcpsTargeting, setHcpsTargeting] = useState("");
  const [billingCodeTargeting, setBillingCodeTargeting] = useState("");
  const [message, setMessage] = useState("");

  const resetFields = () => {
    setEmail("");
    setHcpsTargeting("");
    setBillingCodeTargeting("");
    setMessage("");
  };

  function textFieldChange(event) {
    const { name, value } = event.target;
    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "hcpsTargeting":
        setHcpsTargeting(value);
        break;
      case "billingCodeTargeting":
        setBillingCodeTargeting(value);
        break;
      case "message":
        setMessage(value);
        break;
      default:
        break;
    }
  }
  return (
    <section className="section-sp2">
      <div
        className="container inner-content"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <h2>{title}</h2>
        <p dangerouslySetInnerHTML={{ __html: description }}></p>
        <div
          style={{
            maxWidth: "630px",
            boxShadow: "0px 10px 60px 0px rgba(31, 34, 120, 0.1)",
            paddingTop: "20px",
            paddingInline: "20px",
            borderRadius: "20px",
            background: "#FFFFFF",
          }}
          className=""
        >
          <div className="row">
            <div className="mb-30">
              <form
                className="form-wraper contact-form ajax-form"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const res = await submitFormMutation({
                    senderName: "",
                    email,
                    hcpsTargeting,
                    billingCodeTargeting,
                    message,
                    formName: "hcp-marketing",
                    pageUrl: "hcp-marketing",
                  });

                  if (res.id) {
                    alert(
                      "Thank you for your interest. We will get back to you shortly."
                    );
                    resetFields();
                  }
                  console.log(
                    email,
                    hcpsTargeting,
                    billingCodeTargeting,
                    message
                  );
                }}
              >
                <div className="ajax-message"></div>
                <div className="row">
                  <div className="form-group ">
                    <input
                      name="email"
                      type="email"
                      required
                      value={email}
                      className="form-control"
                      placeholder="Work Email*"
                      onChange={textFieldChange}
                    />
                  </div>
                  <div className="form-group col-md-12">
                    <input
                      name="hcpsTargeting"
                      type="text"
                      required
                      value={hcpsTargeting}
                      className="form-control"
                      placeholder="Which HCPs are you targeting?*"
                      onChange={textFieldChange}
                    />
                  </div>
                  <div className="form-group col-md-12">
                    <input
                      name="billingCodeTargeting"
                      type="text"
                      value={billingCodeTargeting}
                      className="form-control"
                      placeholder="Do you use any billing codes for targeting?"
                      onChange={textFieldChange}
                    />
                  </div>

                  <div className="form-group col-md-12">
                    <input
                      name="message"
                      type="text"
                      value={message}
                      className="form-control"
                      placeholder="Anything else we should know?"
                      onChange={textFieldChange}
                    />
                  </div>
                  <div className="col-lg-12">
                    <button
                      name="submit"
                      type="submit"
                      defaultValue="Submit"
                      className="btn w-100 btn-secondary btn-lg"
                    >
                      Get My Custom Plan
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
